import { GetApprovalReportsRequest } from '@ulysses-inc/harami_api_client'
import { format, subMonths } from 'date-fns'
import * as localStorage from 'src/features/approvals/hooks/approvalReportsStorage'
import { convertToApiFilter } from 'src/features/approvals/hooks/useApprovalReportsFilter'
import { ReportListRow } from 'src/state/ducks/reports/types'
import { ApprovalReportsFilter } from 'src/views/types/utils/ListFilter'
import { GetApprovalReportsFilter } from './types'
export interface ApprovalReportsState {
  reports: Array<ReportListRow>
  count: number
  isLoading: boolean
  error: Error | null
  request: GetApprovalReportsRequest
  filter?: GetApprovalReportsFilter
}

export const addDefaultFromThrough = (
  filter?: ApprovalReportsFilter,
): ApprovalReportsFilter => {
  const end = new Date()
  const start = subMonths(end, 1)
  return {
    ...filter,
    from: filter?.from || format(start, 'yyyy-MM-dd'),
    through: filter?.through || format(end, 'yyyy-MM-dd'),
  }
}

export const initialApprovalReportsState = (): ApprovalReportsState => {
  const { pagination, filter } = localStorage.getStorageData()
  const filterWithDateRange = addDefaultFromThrough(filter)
  return {
    reports: [],
    count: 0,
    isLoading: false,
    error: null,
    request: {
      limit: pagination?.limit || 25,
      offset: pagination?.offset || 0,
    },
    filter: convertToApiFilter(filterWithDateRange),
  }
}
